module.exports = __webpack_public_path__ + "img/l2.4ba35414.jpeg";